/* eslint-disable camelcase */
<template>
  <div
    id="nf-table"
    :class="padding ? 'nf-padding-10' : ''"
    class="nf-table BG_FFFFFF box-bg-style"
  >
    <!-- <nf-edit-table
      :is-edit-table.sync="isEditTable"
      :table-head-list="listData.tableHeadList"
      :store-model-name="storeModelName"
    /> -->
    <el-row align="middle" class="top-operation" justify="flex-start" type="flex">
      <el-col class="title">
        <slot name="top-btn-left" />
      </el-col>
      <el-col
        v-if="
          ($slots['top-btn-right'] && $slots['top-btn-right'][0].children.length) ||
          importUrl ||
          isExportBtn ||
          isSearchBar
        "
      >
        <el-row align="middile" justify="start" type="flex">
          <el-button
            v-if="isSearchBar"
            :size="$store.state.element.elBtnSize"
            icon="el-icon-search"
            type="primary"
            @click="handleSearchBtnClick"
            @keyup.enter="handleSearchBtnClick"
          >
            查询
          </el-button>
          <el-button
            v-if="isSearchBar"
            :size="$store.state.element.elBtnSize"
            icon="el-icon-refresh"
            type="warning"
            @click="handleResetBtnClick"
          >
            重置
          </el-button>
          <el-button v-if="importUrl" :size="$store.state.element.elBtnSize" icon="el-icon-upload2">
            导入
          </el-button>
          <el-button
            v-if="isExportBtn"
            :size="$store.state.element.elBtnSize"
            style="height: 32px; margin-left: 10px"
            @click="handleExportClick"
          >
            导出EXCEL
          </el-button>
          <slot name="top-btn-right" />
        </el-row>
      </el-col>
    </el-row>
    <el-row v-if="addBtnLink" class="addBtnLinkCon">
      <el-button
        :size="$store.state.element.elBtnSize"
        icon="el-icon-plus"
        type="primary"
        @click="handleToAddClick"
      >
        {{ addBtnLinkText }}
      </el-button>
    </el-row>
    <div v-show="listData.tableHeadList && listData.tableHeadList.length" class="table-wrap">
      <slot name="statistics" />
      <el-table
        ref="nfTable"
        :key="elTableHeight || tableHeight"
        :data="listData.list"
        :header-cell-style="{ background: '#f5f5f5', color: '#333' }"
        :header-row-style="{ height: hrowH }"
        :height="elTableHeight || tableHeight"
        :load="load"
        :row-style="{ height: rowH }"
        :row-class-name="tableRowClassName"
        :select-on-indeterminate="true"
        :show-summary="showSummary"
        :summary-method="getSummaries"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        border
        lazy
        row-key="id"
        size="mini"
        stripe
        style="width: 100%"
        tooltip-effect="dark"
        @row-click="handleRowClick"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          v-if="isTableSelect"
          :fixed="true"
          :selectable="selectable"
          type="selection"
          width="55"
        />
        <el-table-column v-if="!isTableSelect" :fixed="true" width="1" />
        <template v-for="(item, index) in newTableHeadList">
          <el-table-column
            v-if="!item.isHide"
            :key="index"
            :fixed="item.fixed"
            :label="item.label"
            :min-width="item.width ? item.width : item.label.length * 14 + 44"
            :prop="item.prop"
            :render-header="item.renderHeader"
            :row-style="{ height: '80px' }"
            :sortable="item.sortable ? false : true"
            :align="item.align"
          >
            <template slot="header">
              <!-- 自定义表头 -->
              <template v-if="item.slotNameHeader">
                <slot :name="item.slotNameHeader" />
              </template>
              <template v-else>
                <!-- <i class="el-icon-setting"/> -->
                {{ item.label }}
                <span v-if="item.tips">
                  <el-tooltip placement="top">
                    <div slot="content">
                      <div v-for="(tip, tipIndex) in item.tips" :key="tipIndex">
                        {{ tipIndex + 1 }}、{{ tip }}
                      </div>
                    </div>
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </span>
              </template>
            </template>
            <template slot-scope="scope">
              <!-- 追加插槽 -->
              <div v-if="item.slotName">
                <slot :name="item.slotName" :scope="scope.row" />
              </div>
              <span v-else class="ellipsis" v-text="scope.row[item.prop]" />
            </template>
          </el-table-column>
        </template>

        <!-- :width="item.width?item.width:item.label.length*14+44" -->
        <el-table-column
          v-if="rightButtons.length > 0"
          :fixed="isOperationFixed ? 'right' : false"
          :width="operationWidth"
        >
          <template slot="header">
            <span>操作</span>
            <el-button
              v-if="isEditTableBtn"
              class="setting-btn"
              icon="el-icon-setting"
              type="text"
              @click="isEditTable = true"
            />
          </template>
          <template slot-scope="scope">
            <el-row class="operation-box" type="flex">
              <div v-for="(item, index) in rightButtons" :key="index">
                <div v-if="rightButtons.length <= 3">
                  <el-button
                    v-if="Object.prototype.toString.call(item) === '[object Function]'"
                    v-show="!item(scope).isHide"
                    :icon="item(scope).icon"
                    :size="$store.state.element.elBtnSize"
                    type="text"
                    @click="item(scope).click(scope)"
                  >
                    {{ item(scope).name }}
                  </el-button>

                  <el-button
                    v-else
                    v-show="!item.isHide"
                    :icon="item.icon"
                    :size="$store.state.element.elBtnSize"
                    type="text"
                    @click="item.click(scope)"
                  >
                    {{ item.name }}
                  </el-button>
                </div>
                <div v-else>
                  <div v-if="index < 2">
                    <el-button
                      v-if="Object.prototype.toString.call(item) === '[object Function]'"
                      v-show="!item(scope).isHide"
                      :icon="item(scope).icon"
                      :size="$store.state.element.elBtnSize"
                      type="text"
                      @click="item(scope).click(scope)"
                    >
                      {{ item(scope).name }}
                    </el-button>

                    <el-button
                      v-else
                      v-show="!item.isHide"
                      :icon="item.icon"
                      :size="$store.state.element.elBtnSize"
                      type="text"
                      @click="item.click(scope)"
                    >
                      {{ item.name }}
                    </el-button>
                  </div>
                  <div v-if="index === 2">
                    <el-dropdown trigger="click">
                      <el-button
                        :size="$store.state.element.elBtnSize"
                        icon="el-icon-more"
                        type="text"
                      >
                        更多
                      </el-button>
                      <el-dropdown-menu slot="dropdown">
                        <div v-for="(item2, index2) in rightButtons" :key="index2">
                          <div v-if="Object.prototype.toString.call(item) === '[object Function]'">
                            <el-dropdown-item
                              v-if="index2 > 1"
                              v-show="!item.isHide"
                              :icon="item2(scope).icon"
                              @click.native="item2(scope).click(scope)"
                            >
                              {{ item2(scope).name }}
                            </el-dropdown-item>
                          </div>
                          <div v-else>
                            <el-dropdown-item
                              v-if="index2 > 1"
                              v-show="!item.isHide"
                              :icon="item2.icon"
                              @click.native="item2.click(scope)"
                            >
                              {{ item2.name }}
                            </el-dropdown-item>
                          </div>
                        </div>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
              </div>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
      <el-row align="middle" class="pagination-box" justify="end" type="flex">
        <slot name="table-foot" />
        <el-row v-if="isPagination" justify="end" type="flex">
          <el-pagination
            :current-page.sync="params.page"
            :hide-on-single-page="singlePage"
            :layout="paginationLayout"
            :page-size="params.size"
            :page-sizes="$store.state.element.pageSizes"
            :pager-count="10"
            :total="listData.total"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </el-row>
      </el-row>
    </div>
  </div>
</template>
<script>
/**
 * @author chai
 * @update 2020年4月23日
 * @module @/commponents/nf-table
 * */

export default {
  name: 'NfTable',
  props: {
    // 是否显示分页
    isPagination: {
      type: Boolean,
      default: true,
    },
    handleToAddClick: {
      type: Function,
      default: () => {},
    },
    // 导入excel地址
    importUrl: {
      type: String,
      default: '',
    },
    // 导出excel按钮是否显示
    isExportBtn: {
      type: Boolean,
      default: false,
    },
    // 查询和重置框
    isSearchBar: {
      type: Boolean,
      default: false,
    },
    // 多选回调方法
    onTableSelect: {
      type: Function,
      default: () => {},
    },
    // 是否显示表格的多选按钮
    isTableSelect: {
      type: Boolean,
      default: false,
    },
    // 添加按钮路由路径
    addBtnLink: {
      type: String,
      default: '',
    },
    // 添加按钮文字
    addBtnLinkText: {
      type: String,
      default: '添加',
    },
    // vuex Model 名称
    storeModelName: {
      type: String,
      required: true,
      default: '',
    },
    // 操作按钮
    rightButtons: {
      type: Array,
      default: () => [],
    },
    // 是否显示合计
    showSummary: {
      type: Boolean,
      default: false,
    },
    exportUrl: {
      type: String,
      default: '',
    },
    // 是否开启编辑表头功能
    isEditTableBtn: {
      type: Boolean,
      default: true,
    },
    // creatd 函数 是否请求列表数据
    isGetList: {
      type: Boolean,
      default: true,
    },
    // table的高度
    elTableHeight: {
      type: [Number, String],
      default: 0,
    },
    // 组件布局，子组件名用逗号分隔
    paginationLayout: {
      type: String,
      default: 'total,sizes, prev, pager, next',
    },
    // 点击分页监听变化
    onHandleCurrentChange: {
      type: [Function, Boolean],
      default: false,
    },
    // 表格 当某一行被点击时会触发该事件
    onTableRowClick: {
      type: [Function, Boolean],
      default: false,
    },
    // 树形数据与懒加载 https://element.eleme.cn/#/zh-CN/component/table
    treeLoadFn: {
      type: [Function, Boolean],
      default: false,
    },
    // 操作按钮是否固定在右侧浮动
    isOperationFixed: {
      type: Boolean,
      default: false,
    },
    // 点击查询按钮
    onHandleSearchBtnClick: {
      type: [Function, Boolean],
      default: false,
    },
    // 点击重置按钮触发
    onHandleResetBtnClick: {
      type: [Function, Boolean],
      default: false,
    },
    renderHeader: {
      type: [Function, Boolean],
      default: false,
    },
    // 表格行高
    rowH: {
      type: String,
      default: '60px',
    },
    //  表头行高
    hrowH: {
      type: String,
      default: '40px',
    },
    currentPageSize: {
      type: Number,
      default: 20,
    },
    // 只有一页时是否隐藏
    singlePage: {
      type: Boolean,
      default: false,
    },
    padding: {
      type: Boolean,
      default: true,
    },
    selectable: Function,
  },
  data() {
    return {
      // 多选数据
      multipleSelection: [],
      // 记录全选 还是反选
      checkboxGroup1: [],
      // 表头数据
      tableHeadList: [
        {
          label: '姓名',
          prop: 'name',
          fixed: true,
        },
      ],
      // 列表list数据
      tableDatalist: [
        {
          name: '1王小虎',
          age: '2',
        },
      ],
      // 是否显示编辑表头 弹出层
      isEditTable: false,
    };
  },
  computed: {
    // 新生成的表头数据 过滤表头checked数据
    newTableHeadList() {
      return (
        this.listData.tableHeadList &&
        this.listData.tableHeadList.filter(item => item.checked === 1)
      );
    },
    // table高度
    tableHeight() {
      return this.$store.state.element.tableHeight;
    },
    // 头部固定高度
    headerHeight() {
      return this.$store.state.settings.headerHeight;
    },
    // 获取当前默认页码
    // currentPageSize () {
    //     return this.$store.state.element.currentPageSize;
    // },
    // 从store里读取列表数据
    listData() {
      return this.$store.state[this.storeModelName].listData;
    },
    // 列表接口穿参数据
    params() {
      return this.$store.state[this.storeModelName].postParams;
    },
    // 动态计算操作栏宽度
    operationWidth() {
      let sizeNum = 0;
      // 距离左边距离
      const paddingLeftPx = 16;
      // 设置按钮最多显示个数
      const lenMax = 3;
      // 操作按钮实际个数
      const buttonLen = this.rightButtons.length;
      // 最多展示三个按钮 如果大于三个按钮 第三就显示的是更多 所以最大值是3
      const len = buttonLen >= lenMax ? lenMax : buttonLen;
      // 默认盒子宽度
      const defaultBtnWidth = 32;
      // 一个文字的宽度
      const defaultSizeWidth = 13;
      // 遍历计算～
      this.rightButtons.forEach((item, index) => {
        item = item instanceof Function ? item() : item;
        if (index < 2) {
          sizeNum = sizeNum + item.name.length;
        }
        if (index === 2) {
          if (buttonLen > lenMax) {
            sizeNum = sizeNum + 2;
          } else {
            sizeNum = sizeNum + item.name.length;
          }
        }
      });
      // == 左边距+（按钮个数*默认盒子宽度+（文字个数*默认文字宽度））
      return paddingLeftPx + (len * defaultBtnWidth + sizeNum * defaultSizeWidth);
    },
    // key为列表渲染字端的 tableHeader对象 方便判断当前列 是否使用合集
    tableHeadObj() {
      const obj = {};
      this.newTableHeadList.forEach(item => {
        obj[item.prop] = item;
      });
      return obj;
    },
  },
  async created() {
    // init page
    // this.$store.commit(`${this.storeModelName}/updatePostParams`, {
    //     size: this.currentPageSize
    // })
    if (this.isGetList) {
      this.getList();
    }
  },
  watch: {
    headerHeight: {
      handler(val) {
        if (val) {
          this.getTableHeight();
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.getTableHeight();
    });
  },
  // 销毁的时候 清空搜索条件
  // destroyed(){
  //     // 切换菜单的时候这里清空了时间筛选条件
  //     let params_ = _.cloneDeep(this.params);
  //     for(let key in params_){
  //         params_[key] = '';
  //     }
  //     params_.page = 1;

  //     this.$store.commit(`${this.storeModelName}/updatePostParams`,params_)
  // },
  methods: {
    getTableHeight() {
      const throttleTime = 500;
      const nfBottomHeight = 80;
      const updateHeight = () => {
        if (this.$refs.nfTable) {
          const rootClientHeight = document.documentElement.clientHeight,
            rootScrollHeight = document.documentElement.scrollHeight,
            rootClientWidth = document.documentElement.clientWidth;
          // 表格最小高度 500px
          let tableHeight =
            rootClientHeight -
            this.$refs.nfTable.$el.offsetTop -
            this.headerHeight -
            nfBottomHeight;
          tableHeight = tableHeight < 500 ? 500 : tableHeight;
          // 默认表格高度
          this.$store.commit('updateElementData', {
            rootScrollHeight,
            rootClientHeight,
            rootClientWidth,
            tableHeight,
          });
        }
      };
      // 视图发生变化更新高度
      window.addEventListener('resize', _.throttle(updateHeight, throttleTime));
      updateHeight();
    },
    // 点击搜索按钮
    handleSearchBtnClick() {
      this.$store.commit(`${this.storeModelName}/updatePostParams`, {
        page: 1,
      });
      if (this.onHandleSearchBtnClick instanceof Function) {
        this.onHandleSearchBtnClick();
      } else {
        this.$store.dispatch(`${this.storeModelName}/getList`);
      }
    },
    // 点击重置按钮
    handleResetBtnClick() {
      const data = {};
      const newParams = JSON.parse(JSON.stringify(this.params));
      delete newParams.page;
      delete newParams.size;
      for (const key in newParams) {
        if (key !== 'page' || key !== 'size') {
          if (Array.isArray(newParams[key])) {
            data[key] = [];
          } else {
            data[key] = '';
          }
        }
      }
      if (this.onHandleResetBtnClick) {
        this.onHandleResetBtnClick();
      } else {
        this.$store.commit(`${this.storeModelName}/updatePostParams`, data);
        this.$store.dispatch(`${this.storeModelName}/getList`);
      }
    },
    handleExportClick() {
      const { start_time, end_time } = this.params;
      let { endTime, startTime } = this.params;
      if (Object.prototype.hasOwnProperty.call(this.params, 'start_time')) {
        startTime = start_time;
        endTime = end_time;
      }

      if (!startTime) {
        this.$$message('请填写开始时间', 'error');
        return;
      }

      if (!endTime) {
        this.$$message('请填写结束时间', 'error');
        return;
      }

      const endTime_ = new Date(endTime).getTime();
      const startTime_ = new Date(startTime).getTime();
      if ((endTime_ - startTime_) / (1000 * 60 * 60 * 24) > 92) {
        this.$$message('导出错误：时间超出范围，仅限3个月数据', 'error');
        return;
      }

      this.$refs['nf-export-modal'].show = true;
    },
    load(tree, treeNode, resolve) {
      if (this.treeLoadFn) {
        this.treeLoadFn(tree, resolve);
      }
      // setTimeout(() => {
      //     resolve([
      //         {
      //             id: 31,
      //             date: '2016-05-01',
      //             name: '王小虎',
      //             address: '上海市普陀区金沙江路 1519 弄'
      //         }, {
      //             id: 32,
      //             date: '2016-05-01',
      //             name: '王小虎',
      //             address: '上海市普陀区金沙江路 1519 弄'
      //         }
      //     ])
      // }, 1000)
    },
    // 调用列表接口
    async getList() {
      this.$store.dispatch(`${this.storeModelName}/getList`);
      // this.$nextTick(function () {
      //     if (this.$refs.nfTable.scrollTop && this.$refs.nfTable.bodyWrapper.scrollTop) { this.$refs.nfTable.bodyWrapper.scrollTop = 0 }

      // })
    },
    // 选择多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.onTableSelect(val);
    },
    // 选择分页条数
    handleSizeChange(e) {
      this.$store.commit(`${this.storeModelName}/updatePostParams`, {
        size: e,
        page: 1,
      });
      this.getList();
    },
    // 切换分页
    handleCurrentChange(e) {
      if (this.onHandleCurrentChange instanceof Function) {
        this.onHandleCurrentChange(e);
      } else {
        this.$store.commit(`${this.storeModelName}/updatePostParams`, {
          page: e,
        });
        this.getList();
      }
    },
    // 表哥当某一行被点击触发
    handleRowClick(row, column, event) {
      if (this.onTableRowClick instanceof Function) {
        this.onTableRowClick(row, column, event);
      }
    },
  },
};
</script>

<style lang="scss">
.nf-table {
  margin-top: 0px;
  padding-left: 10px;
  padding-right: 10px;

  .el-table__row {
    height: 34px;
  }

  .el-table {
    transition: all 0.3s;
  }

  // ----------修改elementui表格的默认样式-----------
  .el-table__body-wrapper {
    &::-webkit-scrollbar {
      width: 8px !important;
      height: 8px !important;
    }
  }

  // // 解决表格固定列问题
  // .el-table__fixed,
  // .el-table__fixed-right {
  //     height: calc(100% - 7px) !important;
  //     box-shadow: -5px -2px 10px rgba(0, 0, 0, 0.12) !important;
  //     .el-table__fixed-body-wrapper {
  //         height: calc(100% - 36px) !important;
  //     }
  // }
  // // 当表格没有滚动条时
  // .el-table__body-wrapper.is-scrolling-none ~ .el-table__fixed-right {
  //     height: 100% !important;
  //     bottom: 0 !important;
  //     box-shadow: none !important;
  // }
  // // 当表格有纵向滚动条时
  // .el-table--scrollable-y .el-table__fixed-right {
  //     right: 7px !important;
  // }
  // // 当表格只有横向滚动条，没有纵向滚动条时
  // .el-table--scrollable-x:not(.el-table--scrollable-y)
  //     .el-table__fixed-right {
  //     right: 0 !important;
  // }
  .setting-btn {
    font-size: 16px;
    position: absolute;
    right: 0;
    top: 0;
    height: 23px;
    padding: 0 10px;
    color: #737373;
  }

  .title {
    font-size: 14px;
    width: auto;
  }

  .top-operation {
    margin: 10px 0;
  }

  .pagination-box {
    margin-top: 10px;
  }

  .operation-box {
    button {
      margin-left: 10px;
    }
  }

  .el-pagination {
    padding-right: 0;

    .btn-next {
      margin-right: 0;
    }
  }

  .addBtnLinkCon {
    height: 50px;
    line-height: 50px;
    margin-bottom: 10px;
  }
}
tbody {
  tr,
  td {
    color: #333333 !important;
  }
}
</style>
